import React from 'react';
import classNames from 'classnames';
import styles from 'assets/jss/material-dashboard-pro-react/components/sidebarStyle';
import { makeStyles } from '@material-ui/core/styles';
import Links from './Links';
import ChartInfoIcon from 'assets/img/icons/ChartInfoIcon';
import { useSelector } from 'react-redux';
import { getCommonLabels } from 'redux/modules/dynamicLabels/selectors';
import { remoteConfigSelector } from 'redux/modules/settings/remoteConfig/selectors';
import { isNewDashboardLinkEnabled } from 'utils/killswitch';
import Link from './Link';
import _ from 'lodash';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISidebarWrapperProps {
	miniEnabled: boolean;
	miniActive: boolean;
	color: types.sidebar.color;
	rtlActive: boolean;
	routes: types.routes.ISingleDashboardRoute[];
	pathname: string;
	onLinkClick: () => void;
}

const SidebarWrapper = ({
	color,
	routes,
	rtlActive,
	miniEnabled,
	miniActive,
	pathname,
	onLinkClick,
}: ISidebarWrapperProps) => {
	const classes = useStyles();
	const sidebarWrapperClasses = classNames(classes.sidebarWrapper, {
		[classes.drawerPaperMini]: miniEnabled && miniActive,
	});
	const commonLabels = useSelector(getCommonLabels);
	const remoteConfig = useSelector(remoteConfigSelector);
	const enableNewDashboardLink = isNewDashboardLinkEnabled(remoteConfig);

	const handleClick = () => {
		window.location.href = '/alpha/dashboard';
	};

	return (
		<div className={sidebarWrapperClasses}>
			<Links
				color={color}
				rtlActive={rtlActive}
				routes={routes}
				miniActive={miniActive}
				miniEnabled={miniEnabled}
				pathname={pathname}
				onLinkClick={onLinkClick}
			/>
			{enableNewDashboardLink && (
				<Link
					key={commonLabels?.newDashboardLink}
					miniEnabled={miniEnabled}
					miniActive={miniActive}
					rtlActive={rtlActive}
					route={{
						path: '',
						customPath: '/alpha/dashboard',
						name: commonLabels?.newDashboardLink,
						icon: ChartInfoIcon,
					}}
					color={color}
					pathname={pathname}
					onLinkClick={handleClick}
				/>
			)}
		</div>
	);
};

export default SidebarWrapper;
